import React from "react";
import { useTranslation } from "react-i18next";
import Layout from "src/components/layout/Layout";
import Resume from "src/components/resume/Resume";
import useAuth from "src/hooks/selectors/useAuth";

const DashboardResumePreviewView = () => {
	const { t } = useTranslation("resume-view", {
		keyPrefix: "preview-view",
	});
	const auth = useAuth();
	return (
		<Layout sidebar={<></>}>
			<Layout.Header title={t("title")} backUrl="/dashboard" />
			<Resume id={auth.hid} />
		</Layout>
	);
};

export default DashboardResumePreviewView;
